import * as Fetch from '../../util/Fetch'

export const getUserId = (message) => {
	let tellerId = Fetch.tellerId()
	return tellerId === message.fromId ? message.toId : message.fromId
}
